


// Due to limitations of React https://github.com/facebook/react/issues/13838
// Which replaces all & with &amp; in things like meta content breaking urls for server-side stuff
// so instead of sending &parameters send all params as just one payload so there's no escaping


// adapted from here:
// https://github.com/dankogai/js-base64/blob/main/base64.ts
// because edge throwing up on referencing Buffer which is not alloed



const _mkUriSafe = (src: string) => src
    .replace(/=/g, '').replace(/[+\/]/g, (m0) => m0 == '+' ? '-' : '_');

const _fromCC = String.fromCharCode.bind(String);



const _U8Afrom = typeof Uint8Array.from === 'function'
    ? Uint8Array.from.bind(Uint8Array)
    // @ts-ignore
    : (it, fn: (any) => number = (x) => x) =>
        new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));

// @ts-ignore
const _toUint8Array = (a: string) => _U8Afrom(atob(a), c => c.charCodeAt(0));

const _fromUint8Array = (u8a: Uint8Array) => {
        // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
        const maxargs = 0x1000;
        let strs: string[] = [];
        for (let i = 0, l = u8a.length; i < l; i += maxargs) {
            // @ts-ignore
            strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
        }
        return btoa(strs.join(''));
    };



export function encodePayload<Type>(payloadObj: Type): string {
    const _TE = new TextEncoder()
    return _mkUriSafe(_fromUint8Array(_TE.encode(JSON.stringify(payloadObj))))
}


export function decodePayload<Type>(payloadString: string): Type {
    const _TD = new TextDecoder()
    const decodedString = _TD.decode(_toUint8Array(payloadString.replace(/_/g, "/")))
    return JSON.parse(decodedString) as Type
}
